import React, { useState } from 'react';
import {
  Button,
  Country,
  findPreselectedCountryFromLanguage,
  formatPhoneForApi,
  InternationalPhonePicker,
  tempSupportedDialCodes,
  validation,
} from 'mypages-library';
import { Trans, useTranslation } from 'react-i18next';
import PageTemplate from 'common/PageTemplate/PageTemplate';
import styles from 'common/PageTemplate/PageTemplate.module.scss';

export type EnterPhoneNumberProps = {
  supportPhoneNumber: string;
  phoneNumberHint: string;
  requestSmsToken: (phoneNumber: string) => void;
  isLoading: boolean;
  error: string;
};

const EnterPhoneNumber: React.FC<EnterPhoneNumberProps> = ({
  supportPhoneNumber,
  phoneNumberHint,
  requestSmsToken,
  error,
  isLoading,
}) => {
  const { isPhoneNumberValid } = validation;
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [selectedCountryPhone, setSelectedCountryPhone] = useState<Country>(
    findPreselectedCountryFromLanguage(language)
  );
  const [phoneNumber, setPhoneNumber] = useState('');
  const phoneError = phoneNumber?.length > 0 && !isPhoneNumberValid(phoneNumber);

  const sendTokenDisabled = !phoneNumber || phoneError;

  const onRequestSmsToken = () => {
    requestSmsToken(formatPhoneForApi(phoneNumber, selectedCountryPhone));
  };

  return (
    <PageTemplate dataTestId="change-password-enter-phone-number">
      <h1 className={styles.title}>{t('MPL_CHANGE_PW_ENTER_PHONE_NUMBER_TITLE')}</h1>
      <p className={styles.text}>
        <Trans
          i18nKey="MPL_CHANGE_PW_ENTER_PHONE_NUMBER_DESCRIPTION"
          values={{
            phoneNumberHint,
          }}
          components={{ b: <b /> }}
        />
      </p>
      <InternationalPhonePicker
        setSelectedCountryPhone={setSelectedCountryPhone}
        selectedCountryPhone={selectedCountryPhone}
        phoneNumber={phoneNumber}
        setPhoneNumber={setPhoneNumber}
        errorMessage={phoneError ? t('MPL_INVALID_PHONE_NUMBER') : ''}
        phoneError={phoneError}
        disabled={false}
        placeholderText={t('MPL_CREATE_ACCOUNT_MOBILE_PHONE')}
        supportedDialCodes={tempSupportedDialCodes}
      />
      {error && (
        <p id="change-password-enter-phone-number-error" className={styles.error}>
          {error}
        </p>
      )}
      <Button
        text={t('MPL_RESEND_CODE')}
        primary
        onClick={onRequestSmsToken}
        className={styles.confirmButton}
        dataTestId="change-password-enter-phone-number-send-btn"
        disabled={sendTokenDisabled || isLoading}
        isLoading={isLoading}
      />
      <p className={styles.text}>
        {t('MPL_CHANGE_PW_ENTER_PHONE_NUMBER_CUSTOMER_CARE_DESCRIPTION', { supportPhoneNumber })}
      </p>
    </PageTemplate>
  );
};

export default EnterPhoneNumber;
